import { Suspense, type ComponentType } from 'react'
import { FullScreenSpinner } from '@/components/routing/FullScreenSpinner'

/** Wraps a (lazy) page component in the app-wide Suspense fallback. */
export function suspensePage(Page: ComponentType) {
  return (
    <Suspense fallback={<FullScreenSpinner />}>
      <Page />
    </Suspense>
  )
}
